export const siteSettings = {
  name: "Margin Trade Pro",
  link: "https://margintradepro.net",
  email: "support@margintradepro.net",
  appLink: "https://app.margintradepro.net",
};
